__webpack_require__.p = "/scores/";